import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import SubHeader from '../header/SubHeader.react';
import NavigationEdit from './NavigationEdit.react';
var Navigation = function Navigation(_ref) {
  var navigationAction = _ref.navigationAction;
  useEffect(function () {
    navigationAction({});
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "desktop-navigation"
  }), /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(NavigationEdit, {
    route: "desktop-navigation",
    navBarArr: ['header']
  }))));
};
var mdtp = {
  navigationAction: cmsActions.navigation
};
export default connect(null, mdtp)(Navigation);